import { render, staticRenderFns } from "./SLinkWrapper.vue?vue&type=template&id=0ec10eb8&"
import script from "./SLinkWrapper.vue?vue&type=script&lang=js&"
export * from "./SLinkWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports